import { withDisplayName } from '@hocs/with-display-name'
import { useSubscriptionLinkProps } from '@hooks/links/use-subscription-link-props'
import Button from '@ui/atoms/button'
import { ENHANCED_COMPONENT_TYPE } from '@ui/enhanced-components/types'
import { graphql } from 'gatsby'
import React from 'react'

const ContentfulSubscriptionLinkButton: Utils.EntryFC<
  Queries.ContentfulSubscriptionLinkButtonFragment
> = ({ content, fieldInspectorProps }) => {
  const subscriptionLinkProps = useSubscriptionLinkProps(content.slug)

  return (
    <Button
      {...subscriptionLinkProps}
      {...fieldInspectorProps({
        fieldId: 'slug',
      })}
      className="!mx-auto !mt-8 !w-fit !px-10 !text-085 !font-medium tablet:!mx-0 tablet:!mt-0"
      data-type={ENHANCED_COMPONENT_TYPE.HYPERLINK}
      variant="secondary"
    >
      {content.label}
    </Button>
  )
}

export const query = graphql`
  fragment ContentfulSubscriptionLinkButton on ContentfulSubscriptionLink {
    ...ContentfulEntry
    slug
    label
  }
`

export default withDisplayName(
  ContentfulSubscriptionLinkButton,
  'ContentfulSubscriptionLinkButton'
)
